import React from "react";
import {NavLink, useHistory} from "react-router-dom";
import Router from "router/router";

import * as css from "./css/nav";
import useFetchNav from "@/hooks/useFetchNav";

function Nav(props) {
    const {data: nav} = useFetchNav()
    const {className} = props;
    let history = useHistory();

    return (
        <css.Nav className={className}>
            <css.NavItem>
                <css.NavLink as={NavLink} to={Router.Home.path}>
                    首页
                </css.NavLink>
            </css.NavItem>
            <css.NavItem>
                <css.NavLink
                    as={NavLink}
                    to={Router.Search.path}
                    onClick={e => {
                        e.preventDefault();
                        let category = {
                            id: 0,
                            optId: 0,
                            name: nav?.selfRun,
                            isSelf: true,
                            icon: "",
                            iconActive: "",
                            parentId: -1
                        };

                        const toSearch = ({
                                              categoryId,
                                              categoryName,
                                              categorySelf,
                                              parentId
                                          }) => {
                            let search = "";
                            if (categoryName) {
                                search = `?parentCategoryId=${parentId}&categoryId=${categoryId}&categoryName=${categoryName}&categorySelf=${categorySelf}`;
                            }
                            history.push({
                                pathname: Router.Search.path,
                                search
                            });
                        };

                        toSearch({
                            categoryId: category.optId,
                            categoryName: category.name,
                            categorySelf: category.isSelf,
                            parentId: category.parentId
                        });
                    }}
                >
                    {nav?.selfRun}
                </css.NavLink>
            </css.NavItem>
            <css.NavItem>
                <css.NavLink as={NavLink} to={Router.ShopStreet.path}>
                    {nav?.shopStreet}
                </css.NavLink>
            </css.NavItem>
            <css.NavItem>
                <css.NavLink as={NavLink} to={Router.News.realPath}>
                    {nav?.news}
                </css.NavLink>
            </css.NavItem>
            <css.NavItem>
                <css.NavLink as={NavLink} to={Router.SecKill.path}>
                    {nav?.secKill}
                </css.NavLink>
            </css.NavItem>
            <css.NavItem>
                <css.NavLink as={NavLink} to={Router.Merchant.path}>
                    {nav?.merchant}
                </css.NavLink>
            </css.NavItem>
            <css.NavItem>
                <css.NavLink as={NavLink} to={Router.Introduce.path}>
                    {nav?.introduce}
                </css.NavLink>
            </css.NavItem>
        </css.Nav>
    );
}

export default Nav;
